<template lang="pug">

	b-form.mb-3.mb-lg-0(@submit='()=>false' @reset="resetFilter")

		b-list-group(role='tablist')
			div.mb-3
				b-list-group-item.g-between-center
					| Дни
				b-list-group-item
					b-form-checkbox-group(:options="daysArrOptions" v-model='page.event.filter.days' stacked)

			div(v-for="type in sessCatTypes" :key="type.id" style="margin-bottom:-1px;")
				b-list-group-item.g-between-center(style="cursor:pointer;" @click="$root.$emit('bv::toggle::collapse', `accordion-${type.id}`)")
					| {{ type.title }}
					i.icon-arrow-down.icons.d-block
				b-collapse(visible accordion='my-accordion' role='tabpanel' :id="`accordion-${type.id}`")
					b-list-group-item
						b-form-checkbox(v-for="option in sessCatsOptions(type)" v-model="page.event.filter.cats" :key="option.value" :value="option.value" :class="`custom-checkbox-${option.color}`") {{ option.text }}

		b-button.mt-3(type='reset' variant='danger' block) Очистить

</template>

<script>
	import { mapActions, mapState } from 'vuex'

	// Vue components
	export default {
		name: 'filterComponent',
		components: {},
		mixins: [],
		data: () => ({

		}),
		computed: {
			...mapState(['event','page']),
			...mapState({
				categoryTypes: state => state.event.categoryTypes,
				dates: state => state.event.dates,
			}),

			eventDatesRange(){ return (this.dates.data || []) },
			daysArrOptions(){
				return this.eventDatesRange.reduce( (acc,date) =>
					[...acc, {
						text:  this.$options.filters.dateFormat(date,"d mmmm"),
						value: (new Date(date)).toLocaleDateString(),
					}],[])
			},
			sessCatTypes(){ return this.categoryTypes.data },
		},
		methods: {
			...mapActions('event/nested/categoryTypes', ['getEventCategoryTypes']),

			sessCatsOptions(type) { return type.session_categories.reduce((acc, {title:text, id:value, color}) =>
				[...acc, {text, value, color}], []) },
			resetFilter(){
				this.page.event.filter = {
					days: [],
					cats: [],
				};
			},

			async mountQueue(){
				await this.$store.dispatch('getEventDates', { id:this.event.data.id });
				await this.$store.dispatch('getEventCategoryTypes', { id:this.event.data.id });
				await this.$store.dispatch('getEventSessions', { id:this.event.data.id, params: {approved:true} });
			},
		},
		beforeMount(){
			this.mountQueue();
		},
	}
</script>
